import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Nav from "../Components/Nav";
import Footer from "../Components/Footer";
import { auth, db } from "../config";
import {
  doc,
  onSnapshot, // ✅ Added for real-time listening
  collection,
  query,
  where,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

const Icon = ({ name, className = " ", style = {} }) => {
  const icons = {
    wallet: "fas fa-wallet", chartProfit: "fas fa-chart-line", deposit: "fas fa-cloud-upload-alt",
    withdraw: "fas fa-cloud-download-alt", referral: "fas fa-users", copy: "fas fa-copy",
    check: "fas fa-check", crypto: "fas fa-bitcoin", security: "fas fa-shield-alt",
    support: "fas fa-headset", withdrawal: "fas fa-money-bill-wave",
  };
  return <i className={`${icons[name] || "fas fa-circle"} ${className}`} style={style} />;
};

function Dashboard() {
  const [userData, setUserData] = useState({
    myReferralId: "", fullname: "Valued Member", balance: 0, totalprofit: 0,
    Totaldeposit: 0, total_referral_comissions: 0, Totalwithdrawal: 0, // ✅ Matched reference
  });
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copySuccess, setCopySuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const faLink = document.createElement("link");
    faLink.rel = "stylesheet";
    faLink.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css";
    document.head.appendChild(faLink);

    let unsubUser = null;
    let unsubInvestments = null;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userRef = doc(db, "users", user.uid);
          
          // ✅ Real-time listener for user data (Balance, Total Profit, etc.)
          unsubUser = onSnapshot(userRef, (docSnap) => {
            if (docSnap.exists()) {
              setUserData((prev) => ({ ...prev, ...docSnap.data() }));
            }
          });

          const q = query(collection(db, "investments"), where("userId", "==", user.uid));
          
          // ✅ Real-time listener for investments
          unsubInvestments = onSnapshot(q, (querySnapshot) => {
            const fetched = querySnapshot.docs.map((doc) => doc.data());
            setInvestments(fetched);
          });

        } catch (error) {
          console.error("Error fetching ", error);
          toast.error("Failed to load dashboard data");
        } finally {
          setLoading(false);
        }
      } else {
        navigate("/auth/login");
      }
    });

    return () => {
      unsubscribe();
      if (unsubUser) unsubUser();
      if (unsubInvestments) unsubInvestments();
      if (faLink && document.head.contains(faLink)) {
        document.head.removeChild(faLink);
      }
    };
  }, [navigate]);

  const handleCopyLink = async () => {
    const referralLink = `https://apexyeild.com/register.html?referralid=${userData.myReferralId}`;
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopySuccess(true);
      toast.success("Referral link copied! ", { position: "top-right", autoClose: 2000, icon: <Icon name="check" className="text-success" /> });
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      toast.error("Failed to copy link ", { position: "top-right" });
    }
  };

  const StatCard = ({ title, value, icon, iconColor, linkText, linkHref, gradient }) => (
    <div className="col-sm-6 col-lg-3 mb-4">
      <div className="card border-0 shadow-sm h-100 stat-card" style={{ background: gradient, borderRadius: "16px", overflow: "hidden", transition: "transform 0.2s ease, box-shadow 0.2s ease" }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(0,0,0,0.15)"; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)"; }}>
        <div className="card-body p-4">
          <div className="d-flex align-items-start justify-content-between">
            <div>
              <p className="text-muted small mb-1 text-uppercase ls-05">{title}</p>
              <h3 className="mb-0 fw-bold text-white">${Number(value || 0).toFixed(2)}</h3>
            </div>
            <div className="icon-badge rounded-circle d-flex align-items-center justify-content-center" style={{ width: "48px", height: "48px", background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.2)" }}>
              <Icon name={icon} className={`fa-lg`} style={{ color: iconColor }} />
            </div>
          </div>
          {linkText && linkHref && (
            <a href={linkHref} className="d-inline-block mt-3 text-white-50 small text-decoration-none hover-white" style={{ transition: "color 0.2s ease" }}
              onMouseEnter={(e) => e.target.style.color = "#fff"} onMouseLeave={(e) => e.target.style.color = "rgba(255,255,255,0.7)"}>
              {linkText} <i className="fas fa-arrow-right ms-1 small"></i>
            </a>
          )}
        </div>
        <div style={{ height: "3px", background: `linear-gradient(90deg, transparent, ${iconColor}, transparent)` }} />
      </div>
    </div>
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>APEXYEILD | Dashboard</title>
        <link rel="icon" href="https://apexyeild.com/auth/storage/app/public/photos/IQAXeGtikmark.png1744508352" type="image/png" />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css" integrity="sha512-z3gLpd7yknf1YoNbCzqRKc4qyor8gaKU1qmn+CShxbuBusANI9QpRohGBreCFkKxLhei6S9CQXFEbbKuqLg0DA==" crossOrigin="anonymous" referrerPolicy="no-referrer" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>
      <style>{`
        :root { --gold-primary: #D4AF37; --gold-light: #F4E4BC; --gold-dark: #B89628; --card-dark: #0f172a; --card-darker: #0a0f1d; --text-gold: #fbbf24; --text-muted: #94a3b8; }
        body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; background: #f8fafc; }
        .ls-05 { letter-spacing: 0.05em; } .hover-white:hover { color: #fff !important; }
        .stat-card { position: relative; cursor: default; }
        .stat-card::after { content: ''; position: absolute; inset: 0; border-radius: 16px; padding: 1px; background: linear-gradient(135deg, rgba(212,175,55,0.3), transparent, rgba(212,175,55,0.1)); -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0); mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; opacity: 0; transition: opacity 0.3s ease; }
        .stat-card:hover::after { opacity: 1; }
        .referral-input { border-radius: 10px; border: 1px solid #e2e8f0; background: #fff; font-size: 0.9rem; transition: all 0.2s ease; }
        .referral-input:focus { border-color: var(--gold-primary); box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.15); outline: none; }
        .copy-btn { border-radius: 0 10px 10px 0; border-left: none; background: var(--gold-primary); color: #1a1a1a; font-weight: 500; transition: all 0.2s ease; }
        .copy-btn:hover { background: var(--gold-dark); transform: translateX(2px); }
        .copy-btn.copied { background: #10b981; color: #fff; }
        .tv-widget-container { border-radius: 16px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.08); background: #fff; }
        .section-header { position: relative; padding-bottom: 0.75rem; margin-bottom: 1.5rem; }
        .section-header::after { content: ''; position: absolute; bottom: 0; left: 0; width: 60px; height: 3px; background: var(--gold-gradient, linear-gradient(90deg, var(--gold-primary), var(--gold-dark))); border-radius: 2px; }
        @media (max-width: 768px) { .stat-card .card-body { padding: 1.25rem !important; } .stat-card h3 { font-size: 1.4rem !important; } }
      `}</style>
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      <div className="wrapper">
        <Nav />
        <div className="main-panel bg-light">
          <div className="content bg-light">
            <div className="page-inner">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 pb-2 border-bottom">
                <div>
                  <h2 className="fw-bold text-dark mb-1">Welcome back, <span className="text-primary">{userData.fullname?.split(' ')[0] || 'Member'}</span></h2>
                  <p className="text-muted mb-0">Your crypto investment dashboard</p>
                </div>
                <div className="mt-3 mt-md-0 d-flex gap-2">
                  <a href="/depositpage" className="btn btn-primary btn-sm px-4"><Icon name="deposit" className="me-2" /> Deposit</a>
                  <a href="/withdrawal" className="btn btn-outline-secondary btn-sm px-4"><Icon name="withdraw" className="me-2" /> Withdraw</a>
                </div>
              </div>

              <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "16px" }}>
                <div className="card-body p-4">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div>
                      <h6 className="fw-semibold mb-1">Your Referral Link</h6>
                      <p className="text-muted small mb-0">Share and earn commissions</p>
                    </div>
                    <div className="input-group" style={{ maxWidth: "500px", width: "100%" }}>
                      <input type="text" className="form-control referral-input" value={`https://apexyeild.com/register.html?referralid=${userData.myReferralId}`} readOnly aria-label="Referral link" />
                      <button className={`btn copy-btn ${copySuccess ? 'copied' : ''}`} onClick={handleCopyLink} type="button" aria-label="Copy referral link">
                        <Icon name={copySuccess ? "check" : "copy"} className="me-1" />{copySuccess ? "Copied!" : "Copy"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <div className="livecoinwatch-widget-5" lcw-base="USD" lcw-color-tx="#64748b" lcw-marquee-1="coins" lcw-marquee-2="movers" lcw-marquee-items={8} style={{ borderRadius: "12px", overflow: "hidden" }} />
              </div>

              <div className="section-header"><h4 className="fw-semibold mb-0">Portfolio Overview</h4></div>
              <div className="row g-4">
                <StatCard title="Account Balance" value={userData.balance} icon="wallet" iconColor="#fbbf24" linkText="Add Funds" linkHref="/depositpage" gradient="linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" />
                <StatCard title="Total Profit" value={userData.totalprofit} icon="chartProfit" iconColor="#34d399" linkText="View Plans" linkHref="/deposit" gradient="linear-gradient(135deg, #064e3b 0%, #022c22 100%)" />
                <StatCard title="Total Deposits" value={userData.Totaldeposit} icon="deposit" iconColor="#60a5fa" linkText="Deposit History" linkHref="/dhistory" gradient="linear-gradient(135deg, #1e3a8a 0%, #0c1929 100%)" />
                {/* ✅ Updated to Totalwithdrawal to match reference, with fallback */}
                <StatCard title="Total Withdrawals" value={userData.Totalwithdrawal || userData.Totalwithdrawals || 0} icon="withdrawal" iconColor="#f87171" linkText="Withdrawal History" linkHref="/whistory" gradient="linear-gradient(135deg, #5b21b6 0%, #2e1065 100%)" />
              </div>

              <div className="section-header mt-5"><h4 className="fw-semibold mb-0">Crypto Market Overview</h4></div>
              <div className="tv-widget-container mb-5">
                <div className="tradingview-widget-container">
                  <iframe title="Crypto Market Overview" scrolling="no" allowTransparency="true" frameBorder="0" src="https://s.tradingview.com/embed-widget/market-overview/?locale=en#%7B%22colorTheme%22%3A%22light%22%2C%22dateRange%22%3A%2212M%22%2C%22showChart%22%3Atrue%2C%22locale%22%3A%22en%22%2C%22largeChartUrl%22%3A%22%22%2C%22isTransparent%22%3Afalse%2C%22showSymbolLogo%22%3Atrue%2C%22showFloatingTooltip%22%3Afalse%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22400%22%2C%22plotLineColorGrowing%22%3A%22rgba(41%2C%2098%2C%20255%2C%201)%22%2C%22plotLineColorFalling%22%3A%22rgba(41%2C%2098%2C%20255%2C%201)%22%2C%22gridLineColor%22%3A%22rgba(240%2C%20243%2C%20250%2C%200)%22%2C%22scaleFontColor%22%3A%22%23787B86%22%2C%22belowLineFillColorGrowing%22%3A%22rgba(41%2C%2098%2C%20255%2C%200.12)%22%2C%22belowLineFillColorFalling%22%3A%22rgba(41%2C%2098%2C%20255%2C%200.12)%22%2C%22belowLineFillColorGrowingBottom%22%3A%22rgba(41%2C%2098%2C%20255%2C%200)%22%2C%22belowLineFillColorFallingBottom%22%3A%22rgba(41%2C%2098%2C%20255%2C%200)%22%2C%22symbolActiveColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200.12)%22%2C%22tabs%22%3A%5B%7B%22title%22%3A%22Crypto%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22BINANCE%3ABTCUSDT%22%2C%22d%22%3A%22Bitcoin%22%7D%2C%7B%22s%22%3A%22BINANCE%3AETHUSDT%22%2C%22d%22%3A%22Ethereum%22%7D%2C%7B%22s%22%3A%22BINANCE%3ABNBUSDT%22%2C%22d%22%3A%22BNB%22%7D%2C%7B%22s%22%3A%22BINANCE%3ASOLUSDT%22%2C%22d%22%3A%22Solana%22%7D%2C%7B%22s%22%3A%22BINANCE%3AXRPUSDT%22%2C%22d%22%3A%22XRP%22%7D%2C%7B%22s%22%3A%22BINANCE%3AADAUSDT%22%2C%22d%22%3A%22Cardano%22%7D%5D%2C%22originalTitle%22%3A%22Cryptocurrencies%22%7D%5D%2C%22page-uri%22%3A%22apexyeild.com%2Fdashboard%22%7D" style={{ width: "100%", height: "400px", border: "none" }} />
                </div>
              </div>

              <div className="section-header"><h4 className="fw-semibold mb-0">Live Market Chart</h4></div>
              <div className="tv-widget-container mb-5">
                <div className="tradingview-widget-container">
                  <iframe title="Live Market Chart" scrolling="no" allowTransparency="true" frameBorder="0" src="https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22autosize%22%3Atrue%2C%22symbol%22%3A%22BINANCE%3ABTCUSDT%22%2C%22interval%22%3A%22D%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22locale%22%3A%22en%22%2C%22allow_symbol_change%22%3Atrue%2C%22calendar%22%3Afalse%2C%22support_host%22%3A%22https%3A%2F%2Fwww.tradingview.com%22%7D" style={{ width: "100%", height: "500px", border: "none" }} />
                </div>
              </div>

              {investments.length > 0 && (
                <>
                  <div className="section-header"><h4 className="fw-semibold mb-0">Active Investments</h4></div>
                  <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th className="ps-4 py-3 small text-muted text-uppercase ls-05">Plan</th>
                            <th className="py-3 small text-muted text-uppercase ls-05">Amount</th>
                            <th className="py-3 small text-muted text-uppercase ls-05">ROI</th>
                            <th className="py-3 small text-muted text-uppercase ls-05">Duration</th>
                            <th className="py-3 small text-muted text-uppercase ls-05">Status</th>
                            <th className="py-3 small text-muted text-uppercase ls-05 text-end pe-4">Started</th>
                          </tr>
                        </thead>
                        <tbody>
                          {investments.slice(0, 5).map((inv, idx) => (
                            <tr key={idx} className="border-bottom-light">
                              <td className="ps-4 fw-medium">{inv.plan || "Standard Plan"}</td>
                              <td className="fw-semibold">${Number(inv.amount || 0).toFixed(2)}</td>
                              <td><span className="badge bg-success bg-opacity-10 text-success">{inv.roi}%</span></td>
                              <td>{inv.duration} days</td>
                              <td>
                                <span className={`badge ${inv.status === "active" ? "bg-success bg-opacity-10 text-success" : inv.status === "pending" ? "bg-warning bg-opacity-10 text-warning" : "bg-secondary bg-opacity-10 text-secondary"}`}>
                                  {inv.status?.charAt(0).toUpperCase() + inv.status?.slice(1) || "N/A"}
                                </span>
                              </td>
                              <td className="text-end pe-4 text-muted small">
                                {inv.createdAt?.seconds ? new Date(inv.createdAt.seconds * 1000).toLocaleDateString() : "—"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {investments.length > 5 && (
                      <div className="card-footer bg-transparent border-0 text-center py-3">
                        <a href="/investments" className="text-primary text-decoration-none small fw-medium">View all investments <i className="fas fa-arrow-right ms-1 small"></i></a>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Dashboard;